import { render } from "./ServicesView.html?vue&type=template&id=5c424208&scoped=true&external"
import script from "./ServicesView.js?vue&type=script&lang=js&external"
export * from "./ServicesView.js?vue&type=script&lang=js&external"

import "./ServicesView.css?vue&type=style&index=0&id=5c424208&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c424208"]])

export default __exports__